// columns/TargetValueColumn.tsx
import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import { Label } from "../../../model/Label";
import Icon from "../../../components/ui/Icon";
import VoiceRecognitionButton from "../../../components/ui/voiceButton";
import CopyToClipBoard from "../../../components/ui/CopyToClipBoard";

const TargetValueCellRenderer = (params: GridRenderCellParams<Label>) => {
  const { id, field } = params;
  const value = params.value || "";
  const isEmpty = !value || value.trim().length === 0;

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    params.api.startCellEditMode({ id, field });
  };

  const handleVoiceInput = (text: string) => {
    params.api.startCellEditMode({
      id: params.id,
      field: params.field,
    });
    setTimeout(() => params.api.setEditCellValue({ id: params.id, field: params.field, value: text }), 50);
  };
  return (
    <div className="flex h-full w-full relative">
      <div
        onClick={handleEdit}
        className="cursor-text p-1 w-full rounded-md border border-dashed transition-colors border-gray-300 bg-blue-50 hover:bg-blue-100 hover:border-blue-400"
      >
        {isEmpty ? (
          <div className="flex items-center justify-center h-full text-sm text-gray-500">
            <Icon icon="modify" />
            <span className="ml-1">Click to translate</span>
          </div>
        ) : (
          <div className="h-full">
            <Tooltip title="" placement="top">
              <div className="source-value-container p-1.5 rounded-md border w-full h-full overflow-y-auto whitespace-pre-wrap break-words leading-relaxed bg-gray-50 border-gray-200">
                {value}
              </div>
            </Tooltip>
          </div>
        )}
      </div>
      {/* Floating Button Group */}
      <div className="absolute bottom-2 right-2 flex items-center space-x-2 z-2 text-primary-dark">
        <CopyToClipBoard value={value} />
        <VoiceRecognitionButton onResult={handleVoiceInput} />
      </div>
    </div>
  );
};

export default TargetValueCellRenderer;
